import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>About us</h2>
        <p>
        The feeling of helplessness as you succumb to an addiction or watch a loved one suffer is one of the most painful moments that anyone can experience. The biggest and toughest step toward recovery is deciding to make that initial change. Change is never easy and committing to sobriety is a life-long pursuit.        
        </p>
        <p>
        Steps Recovery Centers is here to help. We offer drug rehab centers across Utah run by experienced staff members who can give you and your family the tools for living in sobriety.
        </p>
        <p>
        Steps Recovery Centers is more than just a place for drug and alcohol addiction rehabilitation; it’s a way of learning and implementing the best path to recovery. When you choose Steps Recovery Centers for your rehab center, you are giving yourself or your loved one the best chance of achieving, and more importantly, maintaining sobriety.
        </p>
        <a
          href="https://g.co/kgs/so88swr"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Steps Recovery Center Residential Rehab - Payson
        </a>
        <br />
        <br />
        <a
          href="https://g.co/kgs/hZG1hpt"
          target="_blank"
          rel="noopener noreferrer"
        >
          Steps Recovery Center Outpatient Rehab - St. George
        </a>
        <br />
        <br />
        <a
          href="https://g.co/kgs/gUbPYA4"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Steps Recovery Center Outpatient Rehab - Orem
        </a>
        <br />
        <br />
        <a
          href="https://g.co/kgs/temQiPo"
          target="_blank"
          rel="noopener noreferrer"
        >
          Steps Recovery Center Outpatient Rehab - Murray
        </a>
      </Wrap>
    </>
  );
};

export default Content;
